import { IconImageM } from "@common/components/icons/IconsM"
import IconButtonM from "@common/components/button/IconButtonM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { pauseActivity } from "@data/redux/actions/activity"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { useNavigation } from "@react-navigation/native"
import React, { useContext, useState } from "react"
import { Dimensions, View } from "react-native"
import { IconButton } from "react-native-paper"
import { SafeAreaView, useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import TimerContainer from "../execute/TimerContainer"
import TodoIcon from "../todo/TodoIcon"
import ConnectionHeader from "./ConnectionHeader"
import QuizReviewModal from "../execute/QuizReviewModal"

const OneStepActivityHeader = (props) => {
    const {
        activity,
        time,
        activityPaused,
        recordStartTime,
        status,
        setStatus,
        field,
        liveMode,
        estimatedDuration,
        startChrono,
        setTime,
        onExit,
        route,
        isInCheckpointOverlay = false,
    } = props

    const dimensions = useContext(DimensionsContext)
    const insets = useSafeAreaInsets()
    const navigation = useNavigation()
    const [quizReviewVisible, setQuizReviewVisible] = useState(false)
    const hasQuizAttempt =
        activity?.has_prerequisite_quiz &&
        (activity?.quiz_status === "passed" ||
            activity?.quiz_status === "failed")
    const schoolSubject = findItemInListWithId(
        activity?.school_subject_id,
        props.schoolSubjects
    )
    const activityTemplate = props.activityTemplates?.find(
        (s) => s?.id === activity?.activity_template_id
    )

    const activityItem = () => {
        return (
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1
                }}
            >
                <View
                    style={{
                        marginLeft: 3,
                        flex: 1,
                    }}
                >
                    <TextM fontWeight={"SemiBold"} fontSize={14}>
                        {activity?.material?.title ?? activity?.title}
                    </TextM>
                    <View style={{
                        alignItems: "center",
                        flexDirection: "row",
                    }}>
                        <IconImageM
                            uri={schoolSubject?.icon}
                            width={9}
                            style={{
                                marginRight: 4,
                            }}
                        />
                        <TextM
                            fontWeight="Light"
                            color={schoolSubject?.color}
                            style={{}}
                            fontSize={9}
                        >
                            {activity?.student_chapter?.chapter?.name
                                ? activity?.student_chapter?.chapter?.name
                                : schoolSubject?.name}
                        </TextM>
                    </View>
                </View>
            </View>
        )
    }

    return (
        <View
            style={{
                width: Dimensions.get("window").width,
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: theme.colors.white,
                borderBottomWidth: 1,
                borderColor: theme.colors.lightMore,
                paddingTop: !isInCheckpointOverlay ? insets.top : 0,
            }}
        >
            <View
                style={{
                    // Fall back to the real window width: DimensionsContext has no
                    // default value, and the checkpoint overlay can hand down a 0
                    // when its own dimensions are missing. Either way the row would
                    // stop spanning the screen, space-between would have nothing to
                    // distribute, and the left and right clusters would both start
                    // at x=0 — stacking the quiz button onto the back arrow.
                    width: dimensions?.width || Dimensions.get("window").width,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: 65,
                }}
            >
                <View
                    style={{
                        flex: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: 10,
                    }}
                >
                    {!liveMode && (
                        <IconButton
                            icon={"arrow-left"}
                            iconColor={theme.colors.primary}
                            size={32}
                            onPress={onExit}
                        />
                    )}
                    {liveMode && !props.hideActivityMenuButton && (
                        <TodoIcon navigation={navigation} route={route} />
                    )}
                    {activityItem()}
                </View>
                {/* flexShrink: 0 + a fixed width around the timer. TimerContainer
                    is styled `flex: 1`, so inside a width-less row it claims the
                    whole line: this cluster grew to the full 390pt, the left one
                    collapsed to 0 (activity title invisible) and everything piled
                    up at the same x. Giving the timer a definite parent stops it
                    inflating the cluster. */}
                <View style={{ flexDirection: "row", alignItems: "center", flexShrink: 0 }}>
                    {hasQuizAttempt && (
                        <IconButtonM
                            icon="clipboard-check"
                            iconColor={theme.colors.primary}
                            size={24}
                            onPress={() => setQuizReviewVisible(true)}
                            accessibilityLabel="Revoir le quiz"
                        />
                    )}
                    <View style={{ width: 110 }}>
                    <TimerContainer
                        liveMode={liveMode}
                        estimatedDuration={estimatedDuration}
                        field={field}
                        recordStartTime={recordStartTime}
                        time={time}
                        setTime={setTime}
                        startChrono={startChrono}
                        status={status}
                        setStatus={setStatus}
                        activityPaused={activityPaused}
                    />
                    </View>
                </View>
            </View>
            {hasQuizAttempt && (
                <QuizReviewModal
                    isVisible={quizReviewVisible}
                    onClose={() => setQuizReviewVisible(false)}
                    activityId={activity?.id}
                />
            )}
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        activityTemplates: state.data.staticData?.activity_templates,
        user: state.data.currentUser?.object,
        isLiveMode: state.liveMode.isLiveModeEnabled,
        schoolSubjects: state.data.staticData?.school_subjects,
        liveSessionId: state.liveMode.liveSessionId,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    pauseActivity,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OneStepActivityHeader)
